import { Box, styled, Typography } from '@mui/material';
import { IconTrash } from 'assets/img';

export const BlockHeader = ({
  title,
  onRemove,
  canRemove,
}: {
  title: string;
  onRemove: () => void;
  canRemove: boolean;
}) => {
  return (
    <HeaderWrapper>
      <Typography>{title}</Typography>
      {canRemove && (
        <Box sx={{ cursor: 'pointer' }}>
          <StyledIconTrash onClick={onRemove} />
        </Box>
      )}
    </HeaderWrapper>
  );
};

const HeaderWrapper = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  flexDirection: 'row',
  alignItems: 'center',
  width: '100%',
  marginBottom: 12,
});

const StyledIconTrash = styled(IconTrash)(({ theme }) => ({
  path: {
    stroke: theme.palette.lwPrimaryAccentLight[100],
  },
}));
